import React from "react";
import { Container } from "react-bootstrap";

const First = () => {
  return (
    <>
      <section className="first-webDevelopment-section">
        <Container>
          <div className="page-title text-center">
            <h1>Fintech Services Design and Development</h1>
            <div className="sub-info">
              <p>
                At Codeffi, we provide website, application development and
                website architecture. While we invest heavily in our team we
                take pride in our work for a diverse set of clients.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
